export default defineAppConfig({
  ui: {
    colors: {
      primary: 'neutral',
      neutral: 'zinc'
    },
    button: {
      defaultVariants: {
        color: 'neutral'
      }
    }
  }
})
